import React, { FC } from 'react';

import classNames from 'classnames';

import { HeadingProps, HeadingTags } from './Heading.interface';

const getHeadingClasses = (variant: HeadingTags, className?: string): string =>
  classNames(`is-rds-${variant}`, className);

const RdsHeading: FC<HeadingProps> = ({
  className,
  variant,
  semanticTag,
  children,
  ...headingAttributes
}) => {
  const Tag = semanticTag || variant;

  return (
    <Tag
      {...headingAttributes}
      className={getHeadingClasses(variant, className)}
    >
      {children}
    </Tag>
  );
};

export default RdsHeading;
